/* ANT Digital — interacciones del sitio 2026. Sin dependencias; todo degrada sin JS. */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FINE = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const lerp = (a, b, t) => a + (b - a) * t;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const ptr = { x: -9999, y: -9999, t: 0, vx: 0 };
  addEventListener('pointermove', e => {
    ptr.vx = e.clientX - (ptr.x < -999 ? e.clientX : ptr.x);
    ptr.x = e.clientX; ptr.y = e.clientY; ptr.t = performance.now();
  }, { passive: true });

  /* ---------- header ---------- */
  const hdr = $('.hdr');
  let lastY = scrollY;
  const onScrollHdr = () => {
    const y = scrollY;
    hdr.classList.toggle('is-solid', y > 30 || document.body.classList.contains('solid-hdr'));
    const menuOpen = document.documentElement.classList.contains('menu-open') || $('.mega.is-open');
    const dy = y - lastY;
    if (menuOpen || y < 500 || dy < -6) hdr.classList.remove('is-hidden');
    else if (dy > 6) hdr.classList.add('is-hidden');
    if (Math.abs(dy) > 6) lastY = y;
    const wa = $('.wa'); if (wa) wa.classList.toggle('is-on', y > 700);
  };
  addEventListener('scroll', onScrollHdr, { passive: true }); onScrollHdr();

  // megamenú
  const megaBtn = $('[data-mega]'), mega = $('.mega');
  if (megaBtn && mega) {
    let tm;
    const open = v => { mega.classList.toggle('is-open', v); megaBtn.setAttribute('aria-expanded', v); if (v) hdr.classList.add('is-solid'); else onScrollHdr(); };
    megaBtn.addEventListener('click', () => open(!mega.classList.contains('is-open')));
    if (FINE) {
      [megaBtn, mega].forEach(el => {
        el.addEventListener('mouseenter', () => { clearTimeout(tm); open(true); });
        el.addEventListener('mouseleave', () => { tm = setTimeout(() => open(false), 220); });
      });
    }
    addEventListener('keydown', e => { if (e.key === 'Escape') { open(false); megaBtn.focus(); } });
    document.addEventListener('click', e => { if (!mega.contains(e.target) && !megaBtn.contains(e.target)) open(false); });
  }
  // menú móvil
  const burger = $('.burger');
  if (burger) burger.addEventListener('click', () => {
    const v = document.documentElement.classList.toggle('menu-open');
    burger.setAttribute('aria-expanded', v);
    document.body.style.overflow = v ? 'hidden' : '';
  });
  $$('.mnav a').forEach(a => a.addEventListener('click', () => { document.documentElement.classList.remove('menu-open'); document.body.style.overflow = ''; }));

  /* ---------- texto dividido en palabras ---------- */
  $$('.split').forEach(el => {
    const walk = node => {
      [...node.childNodes].forEach(n => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(part => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.append(part); return; }
            const w = document.createElement('span'); w.className = 'w';
            const s = document.createElement('span'); s.textContent = part; w.append(s); frag.append(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) walk(n);
      });
    };
    walk(el);
    $$('.w>span', el).forEach((s, i) => s.style.transitionDelay = (i * 0.035) + 's');
  });

  /* ---------- reveal ---------- */
  const rvEls = $$('.rv, .split, .ph-rv');
  if (RM) rvEls.forEach(e => e.classList.add('in'));
  else {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    rvEls.forEach(e => io.observe(e));
    // respaldo: lo que ya quedó arriba del viewport también se muestra
    let raf;
    addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => rvEls.forEach(e => { if (!e.classList.contains('in') && e.getBoundingClientRect().top < innerHeight * .92) e.classList.add('in'); })); }, { passive: true });
  }

  /* ---------- contadores ---------- */
  const fmt = (v, dec) => v.toLocaleString('es-CL', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  const cio = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return; cio.unobserve(e.target);
    const el = e.target, to = parseFloat(el.dataset.count), dec = +(el.dataset.dec || 0), t0 = performance.now(), D = RM ? 1 : 1600;
    const tick = t => { const p = clamp((t - t0) / D, 0, 1), k = 1 - Math.pow(1 - p, 4); el.textContent = fmt(to * k, dec); if (p < 1) requestAnimationFrame(tick); };
    requestAnimationFrame(tick);
  }), { threshold: .4 });
  $$('[data-count]').forEach(e => cio.observe(e));

  /* ---------- HERO: colonia de hormigas ---------- */
  const hero = $('[data-hero]');
  if (hero) {
    const cv = $('.hero__cv', hero), ctx = cv.getContext('2d');
    let W = 0, H = 0, DPR = 1, ants = [], visible = true, time = 0, rect;
    const PHOTO = hero.classList.contains('hero2');
    const N = () => PHOTO ? (innerWidth < 700 ? 50 : 110) : (innerWidth < 700 ? 150 : innerWidth < 1100 ? 260 : 400);
    const size = () => {
      rect = hero.getBoundingClientRect();
      DPR = Math.min(devicePixelRatio || 1, 2); W = rect.width; H = rect.height;
      cv.width = W * DPR; cv.height = H * DPR; ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      const ft = $('.hcards', hero) || $('.hero__foot', hero); footY = ft ? ft.getBoundingClientRect().top - rect.top : H * .9;
      const n = N();
      while (ants.length < n) ants.push(mk(ants.length));
      ants.length = n;
    };
    const mk = i => ({ x: Math.random() * W, y: Math.random() * H, a: Math.random() * 6.28, v: .8 + Math.random() * .7, lane: i % 3, u: Math.random(), s: Math.random() < .22 ? 1 : 0, id: i });
    // tres senderos que ondulan: el "orden"
    // dos senderos que ondulan entre el texto y el titular, y un tercero que camina sobre la línea inferior
    let footY = 0;
    const path = (lane, u) => {
      const x = -60 + u * (W + 120);
      if (lane === 2 || PHOTO) return [x, footY - 6 - (PHOTO ? lane * 9 : 0) + Math.sin(u * 40 + time + lane) * 1.5];
      const base = (innerWidth < 860 ? [.6, .7] : [.3, .4])[lane] * H;
      const amp = H * .045;
      return [x, base + Math.sin(u * 7.5 + time * .35 + lane * 2.1) * amp + Math.sin(u * 2.3 - time * .2) * amp * .6];
    };
    const draw = () => {
      // desvanecer estelas sin tapar el degradé de fondo
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = 'rgba(0,0,0,.42)'; ctx.fillRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'source-over';
      const px = ptr.x - rect.left, py = ptr.y - rect.top;
      const active = performance.now() - ptr.t < 1400 && px > -50 && py > -50 && px < W + 50 && py < H + 50;
      for (const a of ants) {
        let want;
        const dx = px - a.x, dy = py - a.y, d = Math.hypot(dx, dy);
        if (active && d < 280) {
          // remolino alrededor del cursor: el caos
          const toward = Math.atan2(dy, dx);
          want = toward + (a.id % 2 ? 1 : -1) * (d < 90 ? 1.9 : .7);
          a.v = lerp(a.v, 2.6, .08);
        } else {
          a.u += (a.lane === 2 || PHOTO) ? .00045 : (.00055 + a.v * .00022);
          if (a.u > 1) a.u -= 1;
          const [tx, ty] = path(a.lane, a.u);
          const off = (a.lane === 2 || PHOTO) ? 0 : ((a.id * 7) % 11 - 5) * 2.2;
          const ddx = tx - a.x, ddy = ty + off - a.y, dd = Math.hypot(ddx, ddy);
          if (dd > 400) { a.x = tx - 20; a.y = ty + off; } // reaparece en su sendero
          want = Math.atan2(ddy, ddx);
          a.v = lerp(a.v, dd > 30 ? 2.2 : 1.05, .05);
        }
        let diff = Math.atan2(Math.sin(want - a.a), Math.cos(want - a.a));
        a.a += diff * .09 + (Math.random() - .5) * .35;
        a.x += Math.cos(a.a) * a.v; a.y += Math.sin(a.a) * a.v;
        const c = Math.cos(a.a), s = Math.sin(a.a);
        ctx.fillStyle = a.s ? 'rgba(201,244,94,.95)' : 'rgba(235,238,255,.85)';
        ctx.beginPath(); ctx.arc(a.x, a.y, 1.15, 0, 6.283); ctx.fill();
        ctx.beginPath(); ctx.arc(a.x - c * 2.7, a.y - s * 2.7, 1.6, 0, 6.283); ctx.fill();
      }
    };
    const loop = () => { if (!visible || document.hidden) { requestAnimationFrame(loop); return; } time += .016; draw(); requestAnimationFrame(loop); };
    size();
    addEventListener('resize', () => { clearTimeout(size.t); size.t = setTimeout(size, 150); });
    addEventListener('scroll', () => { rect = hero.getBoundingClientRect(); }, { passive: true });
    new IntersectionObserver(es => visible = es[0].isIntersecting).observe(hero);
    const startAnts = () => { ants.forEach(a => { const [x, y] = path(a.lane, a.u); a.x = x; a.y = y + (Math.random() - .5) * 30; }); loop(); };
    if (RM || !FINE || innerWidth < 1024) { cv.style.display = 'none'; }
    else if (document.readyState === 'complete') setTimeout(startAnts, 600);
    else addEventListener('load', () => setTimeout(startAnts, 600));

    // luz que sigue al cursor
    const bg = $('.hero__bg', hero);
    if (bg) hero.addEventListener('pointermove', e => {
      bg.style.setProperty('--mx', ((e.clientX - rect.left) / W * 100).toFixed(1) + '%');
      bg.style.setProperty('--my', ((e.clientY - rect.top) / H * 100).toFixed(1) + '%');
    });

    // título: peso variable por cercanía (el "ant" pesado y el "digital" fino del logo)
    const title = $('.hero__title', hero);
    const chars = $$('.ch', title).map((el, i) => ({ el, base: el.closest('.ln--1') ? 260 : 820, w: el.closest('.ln--1') ? 260 : 820, cx: 0, cy: 0, i }));
    const measure = () => chars.forEach(c => { const r = c.el.getBoundingClientRect(); c.cx = r.left + r.width / 2; c.cy = r.top + r.height / 2 + scrollY; });
    // entrada con desenfoque de movimiento
    chars.forEach((c, i) => {
      c.el.style.transition = RM ? 'none' : `opacity .9s ${.15 + i * .035}s, filter 1s ${.15 + i * .035}s, transform 1.1s cubic-bezier(.22,.8,.2,1) ${.15 + i * .035}s`;
      if (!RM && FINE) { c.el.style.opacity = .02; c.el.style.filter = 'blur(10px)'; c.el.style.transform = 'translateX(.3em)'; }
    });
    const intro = () => requestAnimationFrame(() => chars.forEach(c => { c.el.style.opacity = 1; c.el.style.filter = 'none'; c.el.style.transform = 'none'; }));
    (document.fonts ? document.fonts.ready : Promise.resolve()).then(() => { measure(); intro(); });
    addEventListener('resize', () => setTimeout(measure, 200));
    if (FINE && !RM) {
      let run = false;
      const step = () => {
        let moving = false; const py = ptr.y + scrollY;
        for (const c of chars) {
          const d = Math.hypot(ptr.x - c.cx, py - c.cy);
          const k = clamp(1 - d / 300, 0, 1);
          const target = c.base === 260 ? lerp(260, 900, k * k) : lerp(820, 160, k * k);
          c.w = lerp(c.w, target, .14);
          if (Math.abs(c.w - target) > .5) moving = true;
          c.el.style.setProperty('--w', c.w.toFixed(0));
        }
        if (moving) requestAnimationFrame(step); else run = false;
      };
      title.parentElement.addEventListener('pointermove', () => { if (!run) { run = true; requestAnimationFrame(step); } });
      title.parentElement.addEventListener('pointerleave', () => { ptr.x = -9999; if (!run) { run = true; requestAnimationFrame(step); } });
    }
  }

  /* ---------- palabra gigante con desenfoque (páginas internas) ---------- */
  $$('[data-word]').forEach(w => {
    const bl = $$('.bl', w);
    if (!bl.length || RM) return;
    let v = 0, last = scrollY, raf;
    const tick = () => {
      const dy = Math.abs(scrollY - last); last = scrollY;
      v = lerp(v, Math.min(dy, 60) + Math.abs(ptr.vx) * .4, .12); ptr.vx *= .85;
      bl.forEach((s, i) => { const k = (i + 1) / bl.length; s.style.setProperty('--b', (k * 9 + v * k * .35).toFixed(1) + 'px'); s.style.setProperty('--t', (k * 12 + v * k * 1.4).toFixed(1) + 'px'); s.style.setProperty('--o', (1 - k * .35).toFixed(2)); });
      raf = requestAnimationFrame(tick);
    };
    new IntersectionObserver(es => { cancelAnimationFrame(raf); if (es[0].isIntersecting) tick(); }).observe(w);
  });

  /* ---------- foto del hero: paralaje con cursor y scroll ---------- */
  if (!RM) $$('[data-par]').forEach(m => {
    const sec = m.parentElement; let mx = 0, my = 0, cx = 0, cy = 0, vis = true;
    if (FINE) sec.addEventListener('pointermove', e => { const r = sec.getBoundingClientRect(); mx = (e.clientX - r.left) / r.width - .5; my = (e.clientY - r.top) / r.height - .5; });
    new IntersectionObserver(es => vis = es[0].isIntersecting).observe(sec);
    const tick = () => {
      if (vis) { cx = lerp(cx, mx, .06); cy = lerp(cy, my, .06); const sy = Math.min(scrollY, innerHeight) * .18; m.style.transform = `translate3d(${(-cx * 22).toFixed(1)}px,${(-cy * 14 + sy).toFixed(1)}px,0) scale(1.04)`; }
      requestAnimationFrame(tick);
    };
    tick();
  });

  /* ---------- tarjetas flotantes: inclinación 3D ---------- */
  if (FINE && !RM) $$('.hc, .bx').forEach(c => {
    c.addEventListener('pointermove', e => { const r = c.getBoundingClientRect(); const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5; c.style.transform = `perspective(700px) rotateY(${x * 10}deg) rotateX(${-y * 10}deg) translateY(-4px)`; });
    c.addEventListener('pointerleave', () => c.style.transform = '');
  });

  /* ---------- acordeón horizontal ---------- */
  $$('.caps').forEach(g => {
    const cards = $$('.cap', g);
    const set = c => cards.forEach(x => { const on = x === c; x.classList.toggle('is-on', on); x.setAttribute('aria-expanded', on); });
    cards.forEach(c => {
      if (FINE) c.addEventListener('mouseenter', () => set(c));
      c.addEventListener('click', e => { if (!c.classList.contains('is-on')) { e.preventDefault(); set(c); } });
      c.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && !c.classList.contains('is-on')) { e.preventDefault(); set(c); } });
    });
  });

  /* ---------- diagnóstico ---------- */
  const dx = $('[data-dx]');
  if (dx) {
    const data = JSON.parse($('#dx-data').textContent);
    const card = $('.dx__card', dx), opts = $$('.dx__o', dx);
    const fill = k => {
      const d = data[k];
      $('[data-f=pill]', card).textContent = d.name;
      $('[data-f=t]', card).innerHTML = d.title;
      $('[data-f=p]', card).textContent = d.p;
      $('[data-f=for]', card).innerHTML = d.for.map(x => `<li>${x}</li>`).join('');
      $('[data-f=steps]', card).innerHTML = d.steps.map(x => `<li>${x}</li>`).join('');
      $('[data-f=res]', card).innerHTML = `<b>Resultado:</b> ${d.res}`;
      $('[data-f=go]', card).href = d.url;
      $('[data-f=go] span', card).textContent = 'Ver ' + d.name;
      $('[data-f=cot]', card).href = (window.ANT_CONTACT || '/contacto') + '?etapa=' + k;
      const ph = $('.dx__ph', card);
      if (ph && d.img) {
        const old = $('img.old', ph), src = window.ANT_IMG ? window.ANT_IMG(d.img) : '/img/fotos/' + d.img + '.webp';
        if (old.getAttribute('src') !== src) {
          const im = new Image(); im.src = src; im.alt = ''; im.className = 'new'; ph.insertBefore(im, old.nextSibling);
          const go = () => { requestAnimationFrame(() => im.classList.add('go')); setTimeout(() => { old.remove(); im.className = 'old'; }, RM ? 0 : 950); };
          im.complete ? go() : (im.onload = go);
        }
      }
    };
    const pick = (o, anim = true) => {
      opts.forEach(x => x.setAttribute('aria-checked', x === o));
      if (!anim || RM) { fill(o.dataset.k); return; }
      card.classList.add('out'); card.classList.remove('swap');
      setTimeout(() => { fill(o.dataset.k); card.classList.remove('out'); void card.offsetWidth; card.classList.add('swap'); }, 260);
    };
    opts.forEach((o, i) => {
      o.addEventListener('click', () => pick(o));
      o.addEventListener('keydown', e => {
        const k = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
        if (k) { e.preventDefault(); const n = opts[(i + k + opts.length) % opts.length]; n.focus(); pick(n); }
      });
    });
    pick(opts[0], false);
  }

  /* ---------- haz de luz ligado al scroll (sin fijar la página) ---------- */
  $$('[data-beam]').forEach(sec => {
    const beam = $('.beam', sec), phs = $$('.ph', sec);
    if (!beam) return;
    let raf;
    const upd = () => {
      const r = beam.getBoundingClientRect();
      const p = RM ? 1 : clamp((innerHeight * .82 - r.top) / (innerHeight * .55), 0, 1);
      beam.style.setProperty('--p', p.toFixed(3));
      beam.style.setProperty('--o', p > 0 && p < 1 ? 1 : 0);
      phs.forEach((ph, i) => ph.classList.toggle('lit', p >= i / phs.length + .02));
    };
    addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(upd); }, { passive: true });
    addEventListener('resize', upd); upd();
  });

  /* ---------- proyectos: vista flotante que sigue al cursor ---------- */
  const fl = $('.float');
  if (fl && FINE) {
    const imgs = {};
    let on = false, x = 0, y = 0, tx = 0, ty = 0, rot = 0, raf;
    const loop = () => {
      x = lerp(x, tx, .14); y = lerp(y, ty, .14); rot = lerp(rot, clamp((tx - x) * .05, -8, 8), .1);
      fl.style.transform = `translate3d(${x}px,${y}px,0) translate(-50%,-50%) rotate(${rot}deg) scale(${on ? 1 : .85})`;
      raf = requestAnimationFrame(loop);
    };
    $$('[data-prev]').forEach(r => {
      const src = r.dataset.prev;
      if (!imgs[src]) { const im = new Image(); im.src = src; im.alt = ''; fl.append(im); imgs[src] = im; }
      r.addEventListener('mouseenter', e => {
        Object.values(imgs).forEach(i => i.classList.toggle('is-on', i === imgs[src]));
        if (!on) { x = tx = e.clientX; y = ty = e.clientY; cancelAnimationFrame(raf); loop(); }
        on = true; fl.classList.add('is-on');
      });
      r.addEventListener('mousemove', e => { tx = e.clientX + 40; ty = e.clientY; });
    });
    $$('.idx').forEach(l => l.addEventListener('mouseleave', () => { on = false; fl.classList.remove('is-on'); Object.values(imgs).forEach(i => i.classList.remove('is-on')); setTimeout(() => { if (!on) cancelAnimationFrame(raf); }, 400); }));
  }

  /* ---------- rieles (testimonios): trackpad, rueda, arrastre, flechas y teclado ---------- */
  $$('[data-rail]').forEach(wrap => {
    const rail = $('.rail', wrap), items = [...rail.children], prev = $('[data-prev-btn]', wrap), next = $('[data-next-btn]', wrap), cnt = $('.count', wrap);
    const step = () => items[0].getBoundingClientRect().width + 14;
    const active = () => {
      const c = rail.getBoundingClientRect(); const mid = c.left + c.width / 2;
      let best = 0, bd = 1e9;
      items.forEach((it, i) => { const r = it.getBoundingClientRect(); const d = Math.abs(r.left + r.width / 2 - mid); if (d < bd) { bd = d; best = i; } });
      if (rail.scrollLeft < 4) best = 0;
      else if (rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 4) best = items.length - 1;
      items.forEach((it, i) => it.classList.toggle('is-on', i === best));
      if (cnt) cnt.textContent = String(best + 1).padStart(2, '0') + ' / ' + String(items.length).padStart(2, '0');
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 4;
    };
    let raf; rail.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(active); }, { passive: true });
    prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    rail.tabIndex = 0;
    rail.addEventListener('keydown', e => { if (e.key === 'ArrowRight') { e.preventDefault(); rail.scrollBy({ left: step(), behavior: 'smooth' }); } if (e.key === 'ArrowLeft') { e.preventDefault(); rail.scrollBy({ left: -step(), behavior: 'smooth' }); } });
    // arrastre con mouse
    let down = false, sx = 0, sl = 0, moved = false;
    rail.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; });
    addEventListener('pointermove', e => { if (!down) return; const d = e.clientX - sx; if (Math.abs(d) > 5) { moved = true; rail.classList.add('drag'); } rail.scrollLeft = sl - d; });
    addEventListener('pointerup', () => { if (!down) return; down = false; rail.classList.remove('drag'); if (moved) { const i = Math.round(rail.scrollLeft / step()); rail.scrollTo({ left: i * step(), behavior: 'smooth' }); } });
    rail.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    // clic en una tarjeta lateral la centra
    items.forEach(it => it.addEventListener('click', () => { if (!it.classList.contains('is-on')) it.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }));
    active(); addEventListener('resize', active);
  });

  /* ---------- número gigante con foco de luz ---------- */
  $$('[data-spot]').forEach(el => {
    const sec = el.closest('section') || el;
    sec.addEventListener('pointermove', e => { const r = el.getBoundingClientRect(); el.style.setProperty('--sx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%'); el.style.setProperty('--sy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%'); });
  });

  /* ---------- botones magnéticos ---------- */
  if (FINE && !RM) $$('[data-mag]').forEach(b => {
    b.addEventListener('pointermove', e => { const r = b.getBoundingClientRect(); b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .18}px,${(e.clientY - r.top - r.height / 2) * .3}px)`; });
    b.addEventListener('pointerleave', () => b.style.transform = '');
  });


  /* ================= V3 ================= */
  /* megamenú: vista previa por servicio + resaltado que se desliza */
  const ml = $('.mega__list');
  if (ml) {
    const hl = $('.mega__hl', ml), items = $$('.mega__s', ml), imgs = $$('.mega__img img'), panes = $$('.mega__pane'), pill = $('[data-mega-pill]');
    const setK = a => {
      items.forEach(x => x.classList.toggle('is-on', x === a));
      hl.style.height = a.offsetHeight + 'px'; hl.style.transform = `translateY(${a.offsetTop}px)`;
      const k = a.dataset.k;
      imgs.forEach(i => i.classList.toggle('is-on', i.dataset.k === k));
      panes.forEach(pn => pn.classList.toggle('is-on', pn.dataset.k === k));
      if (pill) pill.textContent = $('.mega__tt b', a).textContent;
    };
    items.forEach(a => { a.addEventListener('mouseenter', () => setK(a)); a.addEventListener('focus', () => setK(a)); });
    const mo = new MutationObserver(() => { if ($('.mega').classList.contains('is-open')) setK($('.mega__s.is-on') || items[0]); });
    mo.observe($('.mega'), { attributes: true, attributeFilter: ['class'] });
  }

  /* barra "en esta página" */
  const snav = $('[data-snav]');
  if (snav) {
    const links = $$('a[href^="#"]:not(.snav__cta)', snav), secs = links.map(a => document.getElementById(a.getAttribute('href').slice(1))).filter(Boolean);
    const heroEl = $('.phero'), ftr = $('footer'), bar = $('.snav__bar', snav);
    const upd = () => {
      const show = heroEl.getBoundingClientRect().bottom < 80 && ftr.getBoundingClientRect().top > innerHeight - 40;
      snav.classList.toggle('is-on', show);
      let cur = null; secs.forEach(sc => { if (sc.getBoundingClientRect().top < innerHeight * .45) cur = sc.id; });
      links.forEach(a => a.classList.toggle('is-on', a.getAttribute('href') === '#' + cur));
      const h = document.documentElement.scrollHeight - innerHeight; bar.style.setProperty('--sp', (scrollY / h).toFixed(3));
    };
    let r2; addEventListener('scroll', () => { cancelAnimationFrame(r2); r2 = requestAnimationFrame(upd); }, { passive: true }); upd();
  }

  /* historia: la foto fija cambia según el bloque que estás leyendo */
  $$('[data-story]').forEach(st => {
    const its = $$('.story__i', st), ims = $$('.story__stick img', st), dots = $$('.story__dots i', st), cnt = $('.story__count', st);
    const n = String(its.length).padStart(2, '0');
    const set = i => { its.forEach((x, j) => x.classList.toggle('is-on', j === i)); ims.forEach((x, j) => x.classList.toggle('is-on', j === i)); dots.forEach((x, j) => x.classList.toggle('is-on', j === i)); if (cnt) cnt.textContent = String(i + 1).padStart(2, '0') + ' / ' + n; };
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) set(+e.target.dataset.i); }), { rootMargin: '-45% 0px -45% 0px' });
    its.forEach(x => io.observe(x));
  });

  /* tarjetas que se dan vuelta */
  $$('.flip').forEach(f => {
    if (FINE) { f.addEventListener('mouseenter', () => f.classList.add('is-flip')); f.addEventListener('mouseleave', () => f.classList.remove('is-flip')); }
    else f.addEventListener('click', () => f.classList.toggle('is-flip'));
    f.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); f.classList.toggle('is-flip'); } });
  });

  /* fases navegables que avanzan solas */
  $$('[data-stepper]').forEach(sp => {
    const tabs = $$('.stp__t', sp), panes = $$('.stp__p', sp); let cur = 0, timer, vis = false, hover = false;
    const D = 7000; tabs.forEach(t => t.style.setProperty('--dur', D / 1000 + 's'));
    const go = (i, user) => {
      cur = (i + tabs.length) % tabs.length;
      tabs.forEach((t, j) => { t.setAttribute('aria-selected', j === cur); t.tabIndex = j === cur ? 0 : -1; t.classList.remove('run'); t.classList.toggle('done', j < cur); });
      panes.forEach((p, j) => p.classList.toggle('is-on', j === cur));
      void tabs[cur].offsetWidth; if (!RM && vis && !hover) tabs[cur].classList.add('run');
      clearTimeout(timer); if (!RM && vis && !hover) timer = setTimeout(() => go(cur + 1), D);
      if (user) tabs[cur].focus();
    };
    tabs.forEach((t, i) => { t.addEventListener('click', () => go(i)); t.addEventListener('keydown', e => { const k = { ArrowRight: 1, ArrowLeft: -1 }[e.key]; if (k) { e.preventDefault(); go(cur + k, true); } }); });
    sp.addEventListener('mouseenter', () => { hover = true; clearTimeout(timer); tabs[cur].classList.remove('run'); });
    sp.addEventListener('mouseleave', () => { hover = false; go(cur); });
    new IntersectionObserver(es => { vis = es[0].isIntersecting; if (vis) go(cur); else clearTimeout(timer); }, { threshold: .35 }).observe(sp);
  });

  /* checklist que se marca sola */
  $$('[data-ticks]').forEach(sec => {
    const ts = $$('.tick', sec), nEl = $('[data-tick-n]', sec), fg = $('.tcount .fg', sec), C = 213.6;
    let done = false;
    new IntersectionObserver(es => {
      if (!es[0].isIntersecting || done) return; done = true;
      ts.forEach((t, i) => setTimeout(() => { t.classList.add('on'); nEl.textContent = i + 1; fg.style.strokeDashoffset = (C * (1 - (i + 1) / ts.length)).toFixed(1); }, RM ? 0 : 200 + i * 140));
    }, { threshold: .25 }).observe(sec);
  });

  /* proyectos: recorrer la tienda completa al pasar el cursor */
  $$('[data-scroll]').forEach(box => {
    const im = $('img.lg', box);
    const calc = () => { const dy = Math.max(0, im.offsetHeight - box.offsetHeight); box.style.setProperty('--dy', -dy + 'px'); box.style.setProperty('--dur', Math.max(2, dy / 260).toFixed(1) + 's'); };
    im.complete ? calc() : im.addEventListener('load', calc); addEventListener('resize', calc);
  });

  /* paralaje suave de fotos al hacer scroll */
  if (!RM) {
    const pars = $$('[data-par2], [data-par3]');
    const tick2 = () => { pars.forEach(el => { const r = el.parentElement.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return; const k = (r.top + r.height / 2 - innerHeight / 2) / innerHeight; el.style.transform = `translate3d(0,${(k * -40).toFixed(1)}px,0)`; }); requestAnimationFrame(tick2); };
    if (pars.length) tick2();
  }


  /* metodología del home: rueda + tarjetas que se apilan */
  $$('[data-meth]').forEach(sec => {
    const cards = $$('.mstack', sec), segs = $$('.wheel .seg', sec), wk = $('[data-wk]', sec), wt = $('[data-wt]', sec);
    const names = cards.map(c => $('.glass b', c).textContent); let cur = -1;
    const upd = () => {
      let a = 0;
      cards.forEach((c, i) => { if (c.getBoundingClientRect().top < innerHeight * .55) a = i; });
      cards.forEach((c, i) => { const d = a - i; c.style.transform = d > 0 && innerWidth > 900 ? `scale(${1 - d * .04})` : ''; c.style.filter = d > 0 && innerWidth > 900 ? `brightness(${1 - d * .12})` : ''; });
      if (a !== cur) { cur = a; segs.forEach((s2, i) => { s2.classList.toggle('on', i < a); s2.classList.toggle('cur', i === a); }); wk.textContent = 'Fase 0' + (a + 1); wt.innerHTML = `<span>${names[a]}</span>`; }
    };
    let r3; addEventListener('scroll', () => { cancelAnimationFrame(r3); r3 = requestAnimationFrame(upd); }, { passive: true }); upd();
  });


  /* ================= V5 ================= */
  const countEl = el => { const to = parseFloat(el.dataset.count), dec = +(el.dataset.dec || 0), t0 = performance.now(), D = RM ? 1 : 1300; const tick = t => { const p = clamp((t - t0) / D, 0, 1), k = 1 - Math.pow(1 - p, 4); el.textContent = fmt(to * k, dec); if (p < 1) requestAnimationFrame(tick); }; requestAnimationFrame(tick); };

  /* selector de casos */
  $$('[data-cases]').forEach(sec => {
    const tabs = $$('.cases__b', sec), panes = $$('.case', sec); let cur = 0, timer, vis = false, hover = false; const D = 8000;
    tabs.forEach(t => t.style.setProperty('--dur', D / 1000 + 's'));
    const go = i => {
      cur = (i + tabs.length) % tabs.length;
      tabs.forEach((t, j) => { t.setAttribute('aria-selected', j === cur); t.classList.remove('run'); });
      panes.forEach((p, j) => p.classList.toggle('is-on', j === cur));
      $$('[data-count]', panes[cur]).forEach(countEl);
      void tabs[cur].offsetWidth; clearTimeout(timer);
      if (!RM && vis && !hover) { tabs[cur].classList.add('run'); timer = setTimeout(() => go(cur + 1), D); }
    };
    tabs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    sec.addEventListener('mouseenter', () => { hover = true; clearTimeout(timer); tabs[cur].classList.remove('run'); });
    sec.addEventListener('mouseleave', () => { hover = false; go(cur); });
    new IntersectionObserver(es => { const was = vis; vis = es[0].isIntersecting; if (vis && !was) go(cur); if (!vis) clearTimeout(timer); }, { threshold: .3 }).observe(sec);
  });

  /* manifiesto: las palabras se pintan al bajar */
  $$('[data-mani]').forEach(m => {
    const ws = $$('.w2', m);
    const upd = () => { const r = m.getBoundingClientRect(); const p = RM ? 1 : clamp((innerHeight * .85 - r.top) / (r.height + innerHeight * .35), 0, 1); const n = Math.round(p * ws.length); ws.forEach((w, i) => w.classList.toggle('on', i < n)); };
    let r4; addEventListener('scroll', () => { cancelAnimationFrame(r4); r4 = requestAnimationFrame(upd); }, { passive: true }); upd();
  });

  /* ANT vs agencia tradicional */
  $$('[data-vs]').forEach(sec => {
    const bs = $$('.vs__sw button', sec), pill = $('.vs__sw i', sec);
    const set = b => { bs.forEach(x => x.setAttribute('aria-pressed', x === b)); sec.classList.toggle('is-trad', b.dataset.v === 'trad'); pill.style.width = b.offsetWidth + 'px'; pill.style.transform = `translateX(${b.offsetLeft - 5}px)`; };
    bs.forEach(b => b.addEventListener('click', () => set(b)));
    requestAnimationFrame(() => set(bs[0])); addEventListener('resize', () => set(bs.find(b => b.getAttribute('aria-pressed') === 'true')));
  });

  /* filtro de casos */
  const cf = $('[data-cfilters]');
  if (cf) { const chips = $$('.chip', cf), rows = $$('.crow'); chips.forEach(c => c.addEventListener('click', () => { chips.forEach(x => x.setAttribute('aria-pressed', x === c)); rows.forEach(r => r.hidden = c.dataset.f !== '*' && r.dataset.tipo !== c.dataset.f); })); }

  /* Formulario de Mariano: textos en voz Chile (el esquema viene de su motor) */
  const VOS = [[/Contanos/g, 'Cuéntanos'], [/necesitás/g, 'necesitas'], [/Recargá/g, 'Recarga'], [/\bWhatsApp\b/g, 'Teléfono']];
  $$('.ant-form-mount').forEach(m => new MutationObserver(() => { m.querySelectorAll('label, .ant-form-label, .ant-form-help, .ant-form-success, textarea, input').forEach(el => { if (el.placeholder) VOS.forEach(([a, b]) => el.placeholder = el.placeholder.replace(a, b)); if (el.childNodes.length) el.childNodes.forEach(n => { if (n.nodeType === 3) VOS.forEach(([a, b]) => n.textContent = n.textContent.replace(a, b)); }); }); }).observe(m, { childList: true, subtree: true }));

  /* ---------- acordeón FAQ ---------- */
  $$('.acc__q').forEach(q => q.addEventListener('click', () => q.setAttribute('aria-expanded', q.getAttribute('aria-expanded') !== 'true')));

  /* ---------- filtros de proyectos (selección múltiple) ---------- */
  const fwrap = $('[data-filters]');
  if (fwrap) {
    const chips = $$('.chip', fwrap), cards = $$('.pcard');
    const apply = () => {
      const sel = chips.filter(c => c.dataset.f !== '*' && c.getAttribute('aria-pressed') === 'true').map(c => c.dataset.f);
      chips.find(c => c.dataset.f === '*').setAttribute('aria-pressed', sel.length === 0);
      cards.forEach(c => { const tags = c.dataset.tags.split('|'); c.hidden = sel.length > 0 && !sel.some(s => tags.includes(s)); });
    };
    chips.forEach(c => c.addEventListener('click', () => {
      if (c.dataset.f === '*') chips.forEach(x => x.setAttribute('aria-pressed', 'false'));
      else c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') !== 'true');
      apply();
    }));
  }

  /* ---------- formularios ---------- */
  const qs = new URLSearchParams(location.search);
  $$('form[data-form], form.ant-cform').forEach(f => {
    if (f.classList.contains('ant-cform')) { const et = qs.get('etapa'); if (et) { const r = $(`input[data-etapa="${CSS.escape(et)}"]`, f); if (r) r.checked = true; } return; }
    const box = f.closest('.form');
    const et = qs.get('etapa'); if (et) { const r = $(`input[data-etapa="${CSS.escape(et)}"]`, f); if (r) r.checked = true; }
    f.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = $('button[type=submit]', f), err = $('.form__err', f.parentElement);
      if (!f.reportValidity()) return;
      btn.disabled = true; const label = btn.innerHTML; btn.textContent = 'Enviando…';
      try {
        const body = Object.fromEntries(new FormData(f));
        const res = await fetch(f.action, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        if (!res.ok) throw new Error(res.status);
        box.classList.add('sent');
      } catch (_) {
        if (err) err.style.display = 'block';
        btn.disabled = false; btn.innerHTML = label;
      }
    });
  });
  $$('form[data-news]').forEach(f => f.addEventListener('submit', async e => {
    e.preventDefault(); if (!f.reportValidity()) return;
    const ok = f.nextElementSibling;
    try { await fetch(f.action, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.fromEntries(new FormData(f))) }); } catch (_) {}
    f.style.display = 'none'; if (ok) ok.style.display = 'block';
  }));
})();

/* ---------- blog: índice, tablas y lectura ---------- */
(() => {
  const art = document.querySelector('.art'); if (!art) return;
  art.querySelectorAll('table').forEach(t => { if (!t.parentElement.classList.contains('tw')) { const w = document.createElement('div'); w.className = 'tw'; t.before(w); w.append(t); } });
  const slug = s => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
  const hs = [...art.querySelectorAll('h2')].filter(h => h.textContent.trim());
  hs.forEach(h => { if (!h.id) h.id = slug(h.textContent); });
  const toc = document.querySelector('[data-toc]'), tocm = document.querySelector('[data-tocm]');
  if (hs.length < 3) { toc && toc.remove(); tocm && tocm.remove(); return; }
  const li = hs.map(h => `<li><a href="#${h.id}">${h.textContent.trim()}</a></li>`).join('');
  if (toc) toc.querySelector('ol').innerHTML = li;
  if (tocm) { tocm.querySelector('ol').innerHTML = li; tocm.addEventListener('click', e => { if (e.target.closest('a')) tocm.open = false; }); }
  if (!toc) return;
  const links = [...toc.querySelectorAll('a')];
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) links.forEach(a => a.classList.toggle('is-on', a.hash === '#' + e.target.id)); }), { rootMargin: '-15% 0px -75% 0px' });
  hs.forEach(h => io.observe(h));
})();

/* ---------- banner del inicio: fotos que van pasando ---------- */
(() => {
  const box = document.querySelector('[data-hslides]'); if (!box) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const imgs = [...box.querySelectorAll('.hs')]; if (imgs.length < 2) return;
  const small = matchMedia('(max-width: 860px)').matches;
  const load = im => new Promise(res => { if (im.src) return res(); im.onload = im.onerror = res; im.loading = 'eager'; im.src = small ? im.dataset.srcS : im.dataset.src; });
  let i = 0, visible = true, t;
  new IntersectionObserver(es => { visible = es[0].isIntersecting; }).observe(box);
  const next = async () => {
    const n = (i + 1) % imgs.length;
    await load(imgs[n]);
    if (visible && !document.hidden) { imgs[i].classList.remove('is-on'); imgs[n].classList.add('is-on'); i = n; load(imgs[(n + 1) % imgs.length]); }
    t = setTimeout(next, 3500);
  };
  const start = () => setTimeout(() => { load(imgs[1]); t = setTimeout(next, 2200); }, 800);
  document.readyState === 'complete' ? start() : addEventListener('load', start, { once: true });
})();
